
import React from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

interface ImageViewerProps {
  images: string[];
  currentIndex: number;
  isOpen: boolean;
  onClose: () => void;
  onNext: () => void;
  onPrevious: () => void;
}

const ImageViewer: React.FC<ImageViewerProps> = ({
  images,
  currentIndex,
  isOpen,
  onClose,
  onNext,
  onPrevious,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center">
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white hover:text-gold transition-colors z-10"
        aria-label="Zamknij"
      >
        <X size={32} />
      </button>
      
      <button
        onClick={onPrevious}
        className="absolute left-4 top-1/2 -translate-y-1/2 text-white hover:text-gold transition-colors z-10"
        aria-label="Poprzednie zdjęcie"
      >
        <ChevronLeft size={48} />
      </button>
      
      <button
        onClick={onNext}
        className="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:text-gold transition-colors z-10"
        aria-label="Następne zdjęcie"
      >
        <ChevronRight size={48} />
      </button>
      
      <img
        src={images[currentIndex]}
        alt={`Zdjęcie salonu ${currentIndex + 1}`}
        className="max-w-[90vw] max-h-[90vh] object-contain"
        onClick={(e) => e.stopPropagation()}
      />
      
      <div
        className="absolute inset-0 cursor-pointer"
        onClick={onClose}
      />
    </div>
  );
};

export default ImageViewer;
